import { useFileStatusCaption } from '@/features/export_files/List/Table/Columns/Cells/hooks/useFileStatusCaption';
import { ExportFileStatus } from '@/features/export_files/List/type';
import {
  Caption,
  IconApproval,
  IconError,
  IconPending,
} from '@moneyforward/ap-frontend-components';
import cx from 'classnames';
import { FC, memo } from 'react';
import styles from '../column.module.scss';

type Props = {
  status: ExportFileStatus;
};

export const FileStatusCell: FC<Props> = memo(({ status }) => {
  const { label, colorType } = useFileStatusCaption(status);

  let IconComponent;
  switch (status) {
    case 'processing':
      IconComponent = IconPending;
      break;
    case 'failed':
      IconComponent = IconError;
      break;
    case 'done':
      IconComponent = IconApproval;
      break;
    default:
      IconComponent = null;
  }

  const captionType = colorType === 'default' ? 'helper' : colorType;

  return (
    <div className='file-status-cell'>
      <Caption
        type={captionType}
        icon={false}
        data-testid={`caption-${captionType}`}
      >
        <div className={cx(styles['file-status-cell-content'])}>
          {IconComponent && (
            <div
              className={
                colorType === 'default'
                  ? cx(styles['status-default-icon'])
                  : undefined
              }
            >
              <IconComponent width={16} height={16} />
            </div>
          )}
          <span
            className={cx(
              styles['status-label'],
              colorType === 'default'
                ? cx(styles['status-default-text'])
                : undefined
            )}
          >
            {label}
          </span>
        </div>
      </Caption>
    </div>
  );
});

FileStatusCell.displayName = 'FileStatusCell';
